export default {
  // ========== Filtros y Selectores ==========
  programType: 'Tipo de {entity}',
  selectProgramType: 'Seleccione Tipo de {entity}',
  selectProgramToFilter: 'Seleccione {entity} para filtrar {sections}',
  selectA: 'Seleccione {article} {entity}',
  level: 'Nivel',
  selectLevel: 'Seleccione un Nivel',
  filterBy: 'Filtrar por {entity}',
  statusFilter: 'Estado',
  statusAll: 'Todas',
  statusActive: 'Activas',
  statusInactive: 'No activas',
  lockedWhileFormOpen: 'No se puede modificar mientras haya un formulario de {entity} abierto para agregar o editar.',

  // ========== Navegación ==========
  navigation: 'Navegación:',

  // ========== Botones de Acciones ==========
  viewSectionDetails: 'Ver detalles de la {entity}',
  sectionNotes: 'Notas de la {entity}',
  assessmentByStudent: 'Assessment por Estudiante',
  sectionEvaluations: '{evaluations} de la {entity}',
  assessmentReport: 'Reporte Assessment',
  evaluationsProgression: 'Progresión de las {entity}',
  toggleSectionStatus: '{action} las Notas y Evaluaciones de la {entity}',

  // ========== Mensajes ==========
  noSearchResults: 'No se encontró resultados para',
  excelRequiresFilters: 'Selecciona un Perfil de Egreso y un Período en los filtros de arriba para poder descargar el Excel.',
  mustSelectProgram: 'Debe seleccionar {entity} antes de Agregar {section}',
  matterLockedAfterCreation: 'La {subject} no se puede cambiar una vez creada la {section}, ya que sus evaluaciones se generan al crearla.',
  egressProfileWithoutCampuses: 'Este {profile} no tiene {campuses} asignadas, por lo que no se puede crear la {section}.',
  goToEgressProfile: 'Ir al {profile} para agregarlas',
  goToMatrix2: 'Ir a la {matrix} para agregarlas',
  egressProfileWithoutSubjects: 'Este {profile} no tiene {subject} registradas, por lo que no se puede crear la {section}.',
  mustAddSubject: 'Debe añadir al menos una {subject} en {program} para crear {section}',
  confirmDelete: '¿Está seguro de que desea eliminar esta instancia de {entity}?',
  deleteWarning: 'Esta acción no se podrá revertir y se eliminarán los objetos referenciados en la parte inferior.',
  sectionDeleted: '{entity} eliminada.',
  sectionStatus: '{entity} {status}',
  active: 'Activa',
  closed: 'Cerrada',

  // ========== Pasos del Formulario ==========
  step1Details: 'Paso 1: Detalles de la {entity}',
  step2AssignStudents: 'Paso 2: Asignar Estudiante(s)',
  step3AssignTeachers: 'Paso 3: Asignar Profesor(es)',
  detailsOf: 'Detalles de la {entity}',
  assignStudents: 'Asignar Estudiante(s)',
  assignTeachers: 'Asignar Profesor(es)',

  // ========== Selectores ==========
  selectEntity: 'Seleccione una {entity}',
  selectEntityWithDashes: '-- Seleccione una {entity} --',

  // ========== Validaciones ==========
  sectionAlreadyExists: 'Ya existe una sección con esas características y nombre.',
  cannotCreateSectionEvaluationErrors: 'La {section} no puede crearse dado que en la {subject} existen evaluaciones con errores.',
  forMoreInfo: 'para más información presione',
  seeMore: 'ver más',

  // ========== Modales ==========
  incompleteInfo: 'Información por Completar',

  // ========== Usuarios ==========
  students: 'Estudiantes',
  teachers: 'Profesores',
  noStudentsAssigned: 'No hay estudiantes asignados a la {entity}',
  studentsList: 'Estudiantes',
  loading: 'Cargando...',

  // ========== Navegación Pasos ==========
  previousStep: 'Paso anterior',
  nextStep: 'Siguiente paso',

  // ========== Confirmaciones ==========
  confirmDeleteSection: '¿Está seguro de que desea eliminar la Sección?',

  // ========== Mensajes de Estado ==========
  creating: 'Creando {entity}...',
  pleaseWaitWhileCreating: 'Por favor, espera mientras se crea.',
  entityCreated: '{entity} creada.',
  entityModified: '{entity} modificada.',
  entityDeleted: '{entity} eliminada.',

  // ========== Modal de Búsqueda por Correos ==========
  emailQuickSearchTitle: 'Búsqueda rápida por correos',
  emailSearchInstruction: 'Escriba los correos separados por coma (,) para su búsqueda rápida.',
  emailSearchMaxLimit: 'Máximo {count} correos por búsqueda.',
  emailSearchPlaceholder: 'ejemplo@correo.com, siguiente@correo.com, otro@correo.com',
  emailsAlreadyAssigned: 'Correos ya asignados ({count}):',
  emailsFound: 'Correos encontrados ({count}):',
  usersWithWrongRole: 'Usuarios encontrados pero con rol incorrecto ({count}):',
  emailsNotFound: 'Correos no encontrados ({count}):',
  selectFoundEmails: 'Seleccionar encontrados',
  newSearch: 'Nueva búsqueda',
  addNewUser: 'Agregar nuevo usuario',
  usersAssigned: 'Usuarios asignados',
  confirmCloseSearch: '¿Está seguro?',
  confirmCloseSearchText: 'Tiene resultados de búsqueda. ¿Desea cerrar sin seleccionar los usuarios encontrados?',
  yesClose: 'Sí, cerrar',
  roleRequired: 'Se requiere rol: {roles}',
  roleNotSpecified: 'rol no especificado',
  selected: 'Seleccionado(s)',
}
